import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
let user = JSON.parse(localStorage.getItem("currentUser"));
export const getClientManagementList = (item) => {
  let url = `${API.Clientlist}?Name=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getClientListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getSpecialClientUsersManagementList = (item) => {
  let url =
    `${API.SpecialClient}?Name=${item.Name}&Company=${item.Company}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getSpecialClientUsersListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getSpecialClientUsersListFailure",
          error: "ERROR",
        });
      });
  };
};
export const putClientManagementDetails = (data) => {
  let items = {
    Name: "",
    PageNumber: 1,
    PageSize: 25,
  };
  let url = `${API.Clientlist}`;
  return (dispatch) => {
    axios
      .put(url, data, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        toast.success("Deleted Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch(getClientManagementList(items));
        dispatch({
          type: "putClientDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putClientDetailsFailure",
          error: "ERROR",
        });
      });
  };
};
export const postClientManagementDetails = (data) => {
  let url = `${API.postClient}`;
  return (dispatch) => {
    axios
      .post(url, data, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        //    dispatch(getClientManagementList(items));
        dispatch({
          type: "postClientDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postClientDetailsFailure",
          error: "ERROR",
        });
      });
  };
};
export const getShipnameListByCompanyName = (item) => {
  let url = `${API.shipNames}?clientId=${item}`;
  return (dispatch) => {
    return axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getshipByCompanySuccess",
          data: response.data.ships,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getshipByCompanyFailure",
          error: "ERROR",
        });
      });
  };
};
/* export const postClientUserDetails = (data) => {
  let searchData = {
    Name: "",
    PageNumber: 1,
    PageSize: 25,
  };
  let url = `${API.ClientUser}`;
  return (dispatch) => {
    axios
      .post(url, data, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        dispatch({
          type: "postClientUserDetailsSuccess",
          data: response.data,
        });
        dispatch(getSpecialClientUsersManagementList(searchData));
      })
      .catch((error) => {
        dispatch({
          type: "postClientUserDetailsFailure",
          error: "ERROR",
        });
      });
  };
}; */
export const putClientUserDetails = (data) => {
  let url = `${API.ClientUser}`;
  let searchData = {
    Name: "",
    Company: "",
    PageNumber: 1,
    PageSize: 25,
  };
  return (dispatch) => {
    axios
      .put(url, data, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        dispatch(getClientManagementList(searchData));
        /* dispatch(getSpecialClientUsersManagementList(searchData)); */
        dispatch({
          type: "postClientUserDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postClientUserDetailsFailure",
          error: "ERROR",
        });
      });
  };
};

export const putSpecialAccesDetails = (data) => {
  let url = `${API.specialAcces}`;
  let searchData = {
    Name: "",
    Company: "",
    PageNumber: 1,
    PageSize: 25,
  };
  return (dispatch) => {
    axios
      .put(url, data, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        dispatch(getSpecialClientUsersManagementList(searchData));
        /* dispatch(getSpecialClientUsersManagementList(searchData)); */
        dispatch({
          type: "postClientUserDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postClientUserDetailsFailure",
          error: "ERROR",
        });
      });
  };
};




export const getClientUserList = (id) => {
  let url = `${API.ClientUser}?clientId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        let fleet =
          response.data &&
          response.data.filter((r) => r.role === "fleetmanager");
        let superintendent =
          response.data &&
          response.data.filter((r) => r.role === "superintendent");
        let executive =
          response.data &&
          response.data.filter((r) => r.role === "technicalexecutive");
        dispatch({ type: "GetFleetManagerlist", data: fleet });
        dispatch({ type: "GetTechSuperintendentlist", data: superintendent });
        dispatch({ type: "GetTechExecutivelist", data: executive });
        dispatch({ type: "ClientUserDetails", data: response.data });
        dispatch({
          type: "getClientUsersListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientUsersListFailure",
          error: "ERROR",
        });
      });
  };
};


export const getClientUserAddList = (id,role) => {
  let url = `${API.GetAddedClientUsersList}?ids=${id}&Role=${role}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        let fleet =response.data &&response.data.filter((r) => r.role === "fleetmanager");
        let superintendent = response.data &&response.data.filter((r) => r.role === "superintendent");
        let executive = response.data &&response.data.filter((r) => r.role === "technicalexecutive");
if(role==="fleetmanager"){
  dispatch({ type: "GetFleetManagerlist", data: fleet });
}
if(role==="technicalexecutive"){
  dispatch({ type: "GetTechExecutivelist", data: executive });
}
if(role==="superintendent"){
  dispatch({ type: "GetTechSuperintendentlist", data: superintendent });
}
      })
      .catch((error) => {
        dispatch({
          type: "getClientUsersListFailure",
          error: "ERROR",
        });
      });
  };
};
